import { z } from 'zod';
import { zodiacSignEnum } from '../../zodiac';
import { birthDateSchema, birthTimeSchema, birthPlaceSchema, birthTimezoneSchema } from '../birth-data';
import {
  dailyCosmicWeatherSchema,
  natalChartDataDebugSchema,
  oracleConversationMessageSchema,
} from '../ai';

const SYNASTRY_DEFAULT_LIMIT = 10;
const SYNASTRY_MAX_LIMIT = 50;

export const dashboardDataInputSchema = z.object({
  sign: zodiacSignEnum,
  language: z.enum(['pt', 'en', 'es']).default('en'),
});

export const askOracleInputSchema = z.object({
  question: z.string().trim().min(1).max(4000),
  sign: zodiacSignEnum,
  language: z.enum(['pt', 'en', 'es']).default('en'),
  chartData: natalChartDataDebugSchema.optional(),
  cosmicWeather: dailyCosmicWeatherSchema.optional(),
  useCosmicDust: z.boolean().optional(),
  conversationHistory: z.array(oracleConversationMessageSchema).max(10).optional(),
});

export const rateLimitStatusInputSchema = z.object({
  serviceType: z.enum(['oracle', 'tarot', 'compatibility']).default('oracle'),
});

export const partnerBirthDataSchema = z.object({
  dob: birthDateSchema,
  birthTime: birthTimeSchema,
  birthPlace: birthPlaceSchema,
  birthPlaceTimezone: birthTimezoneSchema.nullable(),
});

export const synastryReportInputSchema = z.object({
  partnerBirthData: partnerBirthDataSchema,
  partnerName: z.string().trim().max(128).optional().nullable(),
});

export const listSynastryReportsInputSchema = z.object({
  limit: z.number().int().min(1).max(SYNASTRY_MAX_LIMIT).optional().default(SYNASTRY_DEFAULT_LIMIT),
});

export const synastryReportByIdInputSchema = z.object({ id: z.number().int().positive() });

export const compatibilityInputSchema = z.object({
  sign1: zodiacSignEnum,
  sign2: zodiacSignEnum,
});

export const tarotReadingInputSchema = z.object({
  spreadType: z.enum(['daily', 'three-card', 'celtic-cross']).default('daily'),
  language: z.enum(['pt', 'en', 'es']).default('en'),
  slot: z.enum(['career', 'love', 'overall']).optional(),
  drawIndex: z.number().int().min(0).optional(),
});

const natalInterpretationSubjectSchema = z.object({
  name: z.enum([
    'Sun',
    'Moon',
    'Mercury',
    'Venus',
    'Mars',
    'Jupiter',
    'Saturn',
    'Uranus',
    'Neptune',
    'Pluto',
  ]),
  sign: zodiacSignEnum,
  house: z.number().int().min(1).max(12),
});

export const natalInterpretationInputSchema = z.object({
  subject: natalInterpretationSubjectSchema,
  userName: z.string(),
  userId: z.string().optional(),
});

export const locationSuggestionsInputSchema = z.object({ query: z.string().trim().min(2).max(256) });
